import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {AppointmentService} from "../services/appointment.service";
import {EmbedModeService} from "../services/embed-mode.service";

@Injectable()
export class EmbedModeResolver implements Resolve<void> {
  constructor(private embedModeService: EmbedModeService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): void {
    const embedMode = route.queryParamMap.get('embedMode');
    this.embedModeService.setEmbedMode(embedMode);
  }
}
